import {Component, inject, signal, ChangeDetectionStrategy} from "@angular/core"
import {formatForDisplay} from "@common/helpers/utils/dates"
import {TIPPY_REF} from "@ngneat/helipopper"
import {TippyInstance} from "@ngneat/helipopper/config"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-entity-metadata-tooltip",
    imports: [],
    templateUrl: "./entity-metadata-tooltip.component.html",
    styleUrl: "./entity-metadata-tooltip.component.scss",
})
export class EntityMetadataTooltipComponent {
    readonly $data = signal<{
        createdAt?: string | Date | null
        updatedAt?: string | Date | null
        createdBy?: {name: string}
        updatedBy?: {name: string}
    } | null>(inject<TippyInstance>(TIPPY_REF).data)

    protected readonly formatForDisplay = formatForDisplay
}
